// frontend(root)/src/pages/Community.js
import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import ActivityFeed from "../components/community/ActivityFeed";
import Discussions from "../components/community/Discussions";
import UserSearch from "../components/community/UserSearch";
import "./Community.css";

const Community = () => {
  const { isLoggedIn, user } = useAuth();
  const [activeTab, setActiveTab] = useState("feed");

  // Check URL parameters for tab selection on mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get('tab');
    
    if (tab && ['feed', 'discussions', 'users'].includes(tab)) {
      setActiveTab(tab);
    }
  }, []);

  // Update URL when tab changes
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    
    // Update URL without page refresh
    const url = new URL(window.location.href);
    url.searchParams.set('tab', tab);
    
    // Remove any thread or action parameters when switching tabs
    if (tab !== 'discussions') {
      url.searchParams.delete('thread');
      url.searchParams.delete('action');
    }
    
    window.history.pushState({}, '', url.toString());
  };

  return (
    <div className="community-page">
      {/* New Title Section */}
      <div className="community-page-title-container">
        <h1 className="community-page-title">Community</h1>
        <p className="community-page-subtitle">
          Connect with fellow anime and manga enthusiasts
        </p>
      </div>

      <div className="community-tabs">
        <button 
          className={`tab-button ${activeTab === "feed" ? "active" : ""}`}
          onClick={() => handleTabChange("feed")}
        >
          Activity Feed
        </button>
        <button 
          className={`tab-button ${activeTab === "discussions" ? "active" : ""}`}
          onClick={() => handleTabChange("discussions")}
        >
          Discussions
        </button>
        <button 
          className={`tab-button ${activeTab === "users" ? "active" : ""}`}
          onClick={() => handleTabChange("users")}
        >
          Find Users
        </button>
      </div>

      <div className="community-content">
        {!isLoggedIn ? (
          <div className="login-prompt">
            <div className="login-prompt-content">
              <h2>Join the Community</h2>
              <p>Log in or create an account to participate in discussions and follow other anime fans!</p>
              <div className="login-prompt-buttons">
                <a href="/login" className="login-button">Login</a>
                <a href="/signup" className="signup-button">Sign Up</a>
              </div>
            </div>
          </div>
        ) : (
          activeTab === "feed" ? (
            <ActivityFeed />
          ) : activeTab === "discussions" ? (
            <Discussions />
          ) : (
            <UserSearch />
          )
        )}
      </div>
    </div>
  );
};

export default Community;